import { createFileRoute } from '@tanstack/react-router'
import { useSupplyBrandingLibrary } from '../../../../../hooks'
import { BrandingLibrary } from '../../../../../ui'
// eslint-disable-next-line import/no-internal-modules -- TODO fix when deprecating old components
import { BrandLibraryStoreProvider } from '../../../../../ui/constructs/branding/simplified'

export const Route = createFileRoute(
	'/_auth/company/$companyId/settings/branding-library',
)({
	component: RouteComponent,
})

function RouteComponent() {
	const { store } = useSupplyBrandingLibrary()

	return (
		<BrandLibraryStoreProvider store={store}>
			<BrandingLibrary />
		</BrandLibraryStoreProvider>
	)
}
